module.exports = __webpack_public_path__ + "img/uri-logo.f7b42167.png";